import HelmetTags from "../../../../MainComponents/HelmetTags";
import { useMemo, useState } from "react";
import useTable from "../../../../MainComponents/Hooks/useTable";

const Reports = () => {
  const [academiclevel, setAcademicLevel] = useState(1);
  const [academicType, setAcademicType] = useState("scientific");
  const [systemType, setSystemType] = useState("hand_by_hand");

  const reportsParams = useMemo(() => {
    if (academiclevel === 1) return "1/null";
    if (academiclevel === 2) return "2/null";
    if (academiclevel === 3 && academicType === "scientific") {
      return `${academiclevel}/${academicType}/${systemType}`;
    }
    return `${academiclevel}/${academicType}`;
  }, [academiclevel, academicType, systemType]);

  const viewAllStudentsReportsTable = useTable(
    "viewAllStudentsReports",
    "",
    "",
    academiclevel,
    `${academicType}-${systemType}`,
    reportsParams,
    "",
    "",
    "",
    "",
    "",
    true
  );

  return (
    <section className="dark:bg-dark dark:text-light h-full w-full overflow-y-auto px-10 py-10 sm:px-4 flex flex-col items-start md:items-center">
      <HelmetTags title="Reports | Mr.Mohamed Salama" />
      <h2 className=" text-start text-2xl font-bold ">Reports</h2>

      <div
        className={`filters text-center flex justify-between  items-center w-1/2 md:w-full md:flex-col md:px-6 relative my-4 transition-all duration-200 ease-in-out`}
      >
        <button
          onClick={() => setAcademicLevel(1)}
          className={`z-10 py-2 w-1/3 text-base font-semibold  md:w-full ${
            academiclevel === 1 && "rounded-md bg-green duration-300"
          } `}
        >
          1st sec
        </button>
        <button
          onClick={() => setAcademicLevel(2)}
          className={`z-10 py-2 w-1/3 text-base font-semibold  md:w-full ${
            academiclevel === 2 && "rounded-md bg-green duration-300"
          } `}
        >
          2nd sec
        </button>
        <button
          onClick={() => setAcademicLevel(3)}
          className={`z-10 py-2 w-1/3 text-base font-semibold  md:w-full ${
            academiclevel === 3 && "rounded-md bg-green duration-300"
          } `}
        >
          3rd sec
        </button>
      </div>
      {+academiclevel === 3 && (
        <div className="mt-10 flex w-full flex-col items-center gap-4">
          <div className="filters-container bg-light-gray flex w-full justify-center dark:bg-[#121a35]">
            <div className="filters relative flex h-12 w-[800px] items-center justify-between transition-all duration-200 ease-in-out amd-hero:w-28 amd-hero:flex-col">
              <div
                onClick={() => setAcademicType("scientific")}
                className={`calculus flex h-full w-1/2 cursor-pointer items-center justify-center font-semibold amd-hero:h-[calc(450px/9)] amd-hero:w-28 ${
                  academicType === "scientific" ? "bg-green" : ""
                }`}
              >
                Scientific
              </div>

              <div
                onClick={() => setAcademicType("literary")}
                className={`Algebra flex h-full w-1/2 cursor-pointer items-center justify-center font-semibold amd-hero:h-[calc(450px/9)] amd-hero:w-28 ${
                  academicType === "literary" ? "bg-green" : ""
                }`}
              >
                Literary
              </div>
            </div>
          </div>

          {academicType === "scientific" && (
            <div className="filters-container bg-light-gray flex w-full justify-center dark:bg-[#121a35]">
              <div className="filters relative flex h-12 w-[800px] items-center justify-between transition-all duration-200 ease-in-out amd-hero:w-28 amd-hero:flex-col">
                <div
                  onClick={() => setSystemType("hand_by_hand")}
                  className={`flex h-full w-1/2 cursor-pointer items-center justify-center font-semibold amd-hero:h-[calc(450px/9)] amd-hero:w-28 ${
                    systemType === "hand_by_hand" ? "bg-green" : ""
                  }`}
                >
                  ايد بايد
                </div>
                <div
                  onClick={() => setSystemType("normal")}
                  className={`flex h-full w-1/2 cursor-pointer items-center justify-center font-semibold amd-hero:h-[calc(450px/9)] amd-hero:w-28 ${
                    systemType === "normal" ? "bg-green" : ""
                  }`}
                >
                  النظام العادي
                </div>
              </div>
            </div>
          )}
        </div>
      )}
      <div className="flex w-full  items-start justify-center gap-20 lg:flex-col lg:items-center lg:justify-star">
        <div className="h-fit  w-full">{viewAllStudentsReportsTable}</div>
      </div>
    </section>
  );
};

export default Reports;
